import { ViewChild, Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ColetorCustos } from '../../_models';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-pop-up-coletores',
  templateUrl: './popupColetores.component.html',
  styleUrls: ['./popupColetores.component.css']
})
export class PopUpColetoresComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  displayedColumns: string[] = ['codColetorCusto', 'idx', 'descMensagem'];
  dataSource = new MatTableDataSource<ColetorCustos>(this.data);

  constructor(private dialogRef: MatDialogRef<PopUpColetoresComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ColetorCustos[]) { }

  ngOnInit() {
    this.dataSource.paginator = this.paginator;
  }

  closePopup() {
    this.dialogRef.close();
    this.dataSource = new MatTableDataSource();
  }

  exportExcel() {
    const workSheet = XLSX.utils.json_to_sheet(this.dataSource.data, { header: ['codColetorCusto', 'idx', 'descMensagem'] });
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, 'ColetoresErro');
    XLSX.writeFile(workBook, 'ColetoresErro.xlsx');
  }
}
